import * as React from 'react';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { useMutation } from '@tanstack/react-query';
import { IShippingAddress } from '../../../ShippingAddress';
import makeRequest from '../../../../../../Helper/makeRequest';
import { useUser } from '../../../../../../Context/UserContext';

export default function AddressForm(props: {
  onHide: any;
  shippingAddress?: IShippingAddress;
  refetch: any;
  is_vts: boolean;
}) {
  const postMutation = useMutation<undefined, Error, BodyInit>({
    mutationFn: (body) =>
      makeRequest(
        `/api/onlineshop/basket/shipping-addresses?is_vts=${props.is_vts ? '1' : '0'}`,
        'POST',
        body
      ),
  });

  const userContext = useUser();
  const user = userContext.user;

  return (
    <>
      <Form
        id={'form_shipping_address'}
        onSubmit={(event) => {
          event.preventDefault();
          let FORM_DATA = new FormData(event.currentTarget);
          if (props.shippingAddress) {
            FORM_DATA.append(
              'shipping_address_id',
              props.shippingAddress.id.toString()
            );
          }
          let form = event.currentTarget;
          postMutation.mutate(FORM_DATA, {
            onSuccess() {
              form.reset();
              props.onHide();
              props.refetch();
            },
          });
        }}
      >
        <Row className={'mb-3'}>
          <Col>
            <FormControl
              type={'text'}
              defaultValue={
                props.shippingAddress
                  ? props.shippingAddress.companyName
                  : undefined
              }
              placeholder={'Company Name'}
              name={'company_name'}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <FormControl
              type={'text'}
              placeholder={'First Name'}
              defaultValue={
                props.shippingAddress
                  ? props.shippingAddress.firstName
                  : undefined
              }
              required
              name={'first_name'}
            />
          </Col>
          <Col>
            <FormControl
              type={'text'}
              placeholder={'Last name'}
              defaultValue={
                props.shippingAddress
                  ? props.shippingAddress.lastName
                  : undefined
              }
              required
              name={'last_name'}
            />
          </Col>
        </Row>
        <Row className={'mb-3'}>
          <Col>
            <FormControl
              type={'text'}
              placeholder={'Street'}
              defaultValue={
                props.shippingAddress ? props.shippingAddress.street : undefined
              }
              required
              name={'street'}
            />
          </Col>
          <Col>
            <FormControl
              type={'text'}
              placeholder={'House Number'}
              defaultValue={
                props.shippingAddress
                  ? props.shippingAddress.streetNumber
                  : undefined
              }
              required
              name={'street_number'}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <FormControl
              type={'text'}
              placeholder={'Address line 2'}
              defaultValue={
                props.shippingAddress
                  ? props.shippingAddress.street2
                  : undefined
              }
              name={'street2'}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <FormControl
              type={'text'}
              placeholder={'Zip'}
              defaultValue={
                props.shippingAddress ? props.shippingAddress.zip : undefined
              }
              required
              name={'zip'}
            />
          </Col>
          <Col>
            <FormControl
              type={'text'}
              placeholder={'City'}
              defaultValue={
                props.shippingAddress ? props.shippingAddress.city : undefined
              }
              required
              name={'city'}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <input
              type="hidden"
              name="country_erp_id"
              readOnly
              value={
                props.shippingAddress && props.shippingAddress.country
                  ? props.shippingAddress.country.id
                  : user
                  ? user.invoice_country_erp_id
                  : 2 // 2 == Germany
              }
            />
            <FormControl
              style={{ color: 'grey' }}
              type="text"
              disabled
              value={
                props.shippingAddress && props.shippingAddress.country
                  ? props.shippingAddress.country.name
                  : user
                  ? user.invoice_country_name
                  : 'Germany'
              }
            />
          </Col>
        </Row>
      </Form>
    </>
  );
}
